import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

// Icons
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

// Constants
import { NAVY, WHITE } from '../constants';

function BackToButton({ to, description }) {
  return (
    <Link to={to}>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 40 }}>
        <div style={{ width: 18, height: 18, backgroundColor: NAVY, borderRadius: 30, display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: 5 }}>
          <ChevronLeftIcon style={{ color: WHITE, fontSize: 15 }} />
        </div>
        <Typography variant='overline' style={{ color: NAVY }}>Back to {description}</Typography>
      </div>
    </Link>
  );
}
BackToButton.propTypes = {
  to: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};

export default BackToButton;
